import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { PviStore } from '../stores/pvi.store';

export const PviSummaryGuard: CanMatchFn = () => {
  const pviStore = inject(PviStore);
  const router = inject(Router);

  if (!pviStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['pvi', 'form']);
  }
  return true;
};
